import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import { useNavigate } from 'react-router';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useAuth } from '../../contexts/authWindows';
import { useTranslation } from '../../contexts/translation';
import { UserRoles } from '../../types/core/auth.types';
import { paths } from '../../utils/core/routes';
import { ShiftList } from './ShiftList';

export function ShiftPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isReadOnly = user?.roles.includes(UserRoles.Admin) ? false : true;
  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(paths.SHIFTS_CREATE);
      }}
    >
      <AddIcon />
    </Fab>,
  ];

  return (
    <>
      <PageHeader
        title={t('page.shift.main-headline')}
        buttons={isReadOnly ? null : headerButtons}
        xs={6}
      />
      <PageContent>
        <ShiftList isReadOnly={isReadOnly} />
      </PageContent>
    </>
  );
}
